import { Proto } from '@probe/shared'
import { QueryShape } from './view-map'
const MERCATOR_MAX_LAT = 85.05112878

function clampLat(lat: number): number {
    return Math.max(-MERCATOR_MAX_LAT, Math.min(MERCATOR_MAX_LAT, lat))
}

function normalizeLng(lng: number): number {
    let x = lng
    while (x < -180) x += 360
    while (x > 180) x -= 360
    return x
}

export function getMapQueryShape(map: maplibregl.Map): QueryShape {
    const canvas = map.getCanvas()
    const width = canvas.width
    const height = canvas.height

    const corners = [
        map.unproject([0, 0]),
        map.unproject([width, 0]),
        map.unproject([width, height]),
        map.unproject([0, height])
    ]

    const lngs = corners.map((p) => p.lng)
    const lats = corners.map((p) => p.lat)

    const rawMinLng = Math.min(...lngs)
    const rawMaxLng = Math.max(...lngs)
    const rawSpanLng = rawMaxLng - rawMinLng

    const minLat = clampLat(Math.min(...lats))
    const maxLat = clampLat(Math.max(...lats))

    if (rawSpanLng >= 330) {
        return {
            type: 'world',
            minLat,
            maxLat
        }
    }

    if (rawSpanLng > 180) {
        return {
            type: 'wide',
            minLat,
            maxLat
        }
    }

    return {
        type: 'bbox',
        minLng: normalizeLng(rawMinLng),
        maxLng: normalizeLng(rawMaxLng),
        minLat,
        maxLat
    }
}
